export default __webpack_public_path__ + "static/media/store_engagement.c106e898.png";